export default {
  isJson (item) {
    item = typeof item !== 'string'
      ? JSON.stringify(item)
      : item;

    try {
      item = JSON.parse(item);
    } catch (e) {
      return false;
    }

    if (typeof item === 'object' && item !== null) {
      return true;
    }

    return false;
  },

  filterFn (textToSearch, objectToFilter) {
    const needle = textToSearch.toLowerCase();
    return objectToFilter.filter(
      (v) => v.name.toLowerCase().indexOf(needle) > -1
    );
  },
  filterFnWithoutAccents (textToSearch, objectToFilter) {
    const needle = textToSearch.toLowerCase();
    return objectToFilter.filter(
      (v) => v.name.toLowerCase().indexOf(needle) > -1
    );
  },
  getFileNameFromHeader (disposition) {
    let filename = '';
    if (disposition && disposition.indexOf('attachment') !== -1) {
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }
    return filename;
  }
};
